import { NotificationsSettings } from '@tripointe/tripointe-cms/types';
import { NotificationSetting, UserNotificationSetting } from '@tripointe/tripointe-cms/data-access';

export const settingToNotificationInput = ({ name, email, text }: NotificationsSettings) => {
  return {
    name,
    email,
    text
  };
};

export const userNotificationsToSettings = (
  setting: UserNotificationSetting
): NotificationsSettings => {
  const { email, text, name, label } = setting;

  return {
    email,
    text,
    name,
    label
  };
};

export const baseNotificationsToSettings = (
  setting: NotificationSetting
): NotificationsSettings => {
  const { name, label } = setting;

  return {
    name,
    label,
    email: false,
    text: false
  };
};
